import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=8b2d3410&scoped=true&lang=html&"
import script from "./LayoutPublic.vue?vue&type=script&lang=js&"
export * from "./LayoutPublic.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPublic.vue?vue&type=style&index=0&id=8b2d3410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d3410",
  null
  
)

export default component.exports